import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { AuthenticationGuard } from './authentication.guard';
import { LoginComponent } from './login/login.component';
import { TutorialComponent } from './tutorial/tutorial.component';

const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent, data: { title: marker('Auth.Login.Login') }
  }, {
    path: 'tutorial',
    component: TutorialComponent, data: {
      title: marker('Auth.Tutorial.StartNow'),
      canLoad: [AuthenticationGuard]
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class AuthRoutingModule { }
